import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ChromePicker } from 'react-color';

import { BorderRadius, Colors, FontSizes } from '../Theme';

const ColorPicker = ({ color, label, onChange }) => {
  const [showPicker, setShowPicker] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const styles = {
    component: {
      backgroundColor: '#fff',
      borderRadius: BorderRadius.DEFAULT,
      color: Colors.GRAY.hex,
      fontSize: FontSizes.REGULAR,
      border: '1px solid #e5e5e5',
      height: 40,
      position: 'relative',
      display: 'flex'
    },
    trigger: {
      cursor: 'pointer',
      display: 'flex'
    },
    picker: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      transform: 'translateY(100%)',
      zIndex: 100
    },
    scrim: {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    label: {
      fontSize: FontSizes.REGULAR,
      marginRight: 5,
      padding: '0px 12px',
      lineHeight: '40px',
      flex: 1
    },
    selectedColor: {
      width: 40,
      borderRadius: `${BorderRadius.DEFAULT}px 0 0 ${BorderRadius.DEFAULT}px`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    edit: {
      fontSize: 24,
      color: '#fff',
      display: showEdit ? 'block' : 'none'
    }
  };
  const cssColor = color.rgb
    ? 'rgba(' + color.rgb.r + ',' + color.rgb.g + ',' + color.rgb.b + ',' + color.rgb.a + ')'
    : color.hex;

  return (
    <div style={styles.component}>
      {showPicker ? (
        <div onClick={setShowPicker.bind(null, !showPicker)} style={styles.scrim} />
      ) : null}
      <div
        onClick={setShowPicker.bind(null, !showPicker)}
        onMouseOut={setShowEdit.bind(null, false)}
        onMouseOver={setShowEdit.bind(null, true)}
        style={styles.trigger}
      >
        <div style={Object.assign({ backgroundColor: cssColor }, styles.selectedColor)}>
          <i className='mdi mdi-palette' style={styles.edit} />
        </div>
        <div style={styles.label}>{label}</div>
      </div>
      {showPicker ? (
        <div style={styles.picker}>
          <ChromePicker color={color} onChangeComplete={onChange} />
        </div>
      ) : null}
    </div>
  );
};

ColorPicker.propTypes = {
  color: PropTypes.shape({
    hex: PropTypes.string.isRequired,
    rgb: PropTypes.string
  }).isRequired, //this should follow the same rules as react-color color prop
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func
};

export default ColorPicker;
